var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "549.000000pt",
    viewBox: "0 0 300.000000 549.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,549.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390 5269 c-107 -37 -197 -126 -242 -236 l-23 -58 -3 -2210 c-2 -2015 -1 -2215 14 -2270 30 -113 115 -214 222 -263 82 -37 139 -39 1237 -37 l960 1 70 25 c92 32 181 113 227 206 29 59 33 78 38 182 4 64 6 1068 5 2231 l-2 2115 -28 75 c-38 98 -130 195 -221 231 l-59 24 -1070 2 c-1035 2 -1072 1 -1125 -18z m1375 -361 c31 -14 35 -62 6 -78 -12 -6 -111 -10 -253 -10 -198 0 -237 2 -256 16 -29 20 -25 54 8 71 34 17 458 18 495 1z m813 -2166 l2 -1702 -1072 2 -1073 3 -3 1680 c-1 924 0 1690 3 1703 l5 22 1068 -2 1067 -3 3 -1703z m-962 -1947 c61 -36 94 -95 94 -169 0 -32 -5 -67 -11 -79 -17 -33 -61 -77 -94 -95 -39 -20 -131 -20 -171 1 -61 32 -114 114 -114 178 0 32 31 104 58 133 58 62 162 75 238 31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.b16b9d8811a09ff07ac47ba85c026699.svg";
export { ForwardRef as ReactComponent };